module.exports = __webpack_public_path__ + "static/media/galactic-republic.1f456341.svg";